import { Card } from "react-bootstrap";
import { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import PriceDetail from "./Components/PriceDetail";
import AssignCabin from "./Components/AssignCabin";
import { SelectedUserContext } from "../../../context/selecteduser.context";
import { getAvailableRooms, getCommonOption, getItinerarybyEnquiryId } from "../../../api/itinerary.api";
import { useParams } from "react-router-dom";
import { checkExistCustomerEnquiry, getCustomerDataById } from "../../../api/customer.api";
import CustomSelect from "../../../components/CustomSelect/CustomSelect";
import { getQuotationRoomPrices } from "../../../api/quotation.api";
import SnackbarContext from "../../../context/snackbar.context";
import './style.scss'
interface IBuildQuotation { 
  setStepNumber: Dispatch<SetStateAction<number>>;
}

const BuildQuotation: React.FC<IBuildQuotation> = ({ setStepNumber }) => {
  const { customerId } = useParams();
  const snackbarCtx = useContext(SnackbarContext);
  const { selectedUser, handleSelectedUser, existingEnquiry, handleExistingEnquiry, handleAddRemoveCabinLoader, lastCabinUpdates, handleLastCabinUpdates } = useContext(SelectedUserContext);
  
  const [show, setShow] = useState(false);
  const [netPrice, setNetPrice] = useState<any>({ total: 0, cabin_names: [], cabin_fares: [], ssr_names: [], ssr_fares: [], service_tax_and_levies: 0, gst: 0, discount_category: {}, discount: 0, port_charges: 0, gratuity: 0, fuel_surcharge: 0 });
  const [itineraryDetails, setItineraryDetails] = useState([]);
  const [cabinsData, setCabinData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [specialPricingUpgradeOffer, setSpecialPricingUpgradeOffer] = useState({specialPricing: false, upgradeOffer: false});
  const [cabinCategoryData, setCabinCategoryData] = useState<any>({}); //{ categoryId: [{ categoryId, guests:{} }], ... };
  const [commonOption, setCommonOption] = useState({
    "assignment": {
      "AUTO": "auto_assign",
      "MANUAL": "manual_assign"
    },
    "preference": {
      "CONNECTING_ROOMS": "connecting_rooms",
      "WHEEL_CHAIR_ACCESS": "wheel_chair_access",
      "BALCONY_VIEW": "balcony_view",
      "SQUARE_WINDOW": "square_window"
    },
    "room_selection": {
      "AGENT": "agent_selection",
      "GUEST": "guest_selection"
    }
  });
  const [payloadObj, setPayloadObj] = useState({
    itineraryId: '',
    enquiryId: existingEnquiry.id,
    //temporary hardcoded MANUAL Assign instead of AUTO + Guest Room Selection Type 
    // assignmentType: commonOption?.assignment?.AUTO,
    assignmentType: commonOption?.assignment?.MANUAL,
    roomSelectionType: commonOption?.room_selection?.GUEST,

    special_request_ids:[],
    preference: [],
    rooms: [],
  });

  const getItineraryOption = async (id: string) => {
    const response = await getItinerarybyEnquiryId(id);
    if (response?.status === 200) {
      const { result } = response?.result;
      setItineraryDetails(result?.map((item: any) => { return { label: item?.route, value: item?.id, tripType: item?.trip_type, nightCount: item?.night_count, shipName: item?.ship_name, startTime: item?.start_time, endTime: item?.end_time, originPort: item?.origin_port, destinationPort: item?.destination_port } }));
      setPayloadObj({ ...payloadObj, itineraryId: result[0]?.id });
      getAvailableRoomData(result[0]?.id, specialPricingUpgradeOffer.specialPricing, specialPricingUpgradeOffer.upgradeOffer);
    }
  }

  const handleItineraryOptionChange = (option: any) => {
    setPayloadObj({ ...payloadObj, rooms: [], itineraryId: option?.value });
    //resetting prev states if any
    setNetPrice({ total: 0, cabin_names: [], cabin_fares: [], ssr_names: [], ssr_fares: [], service_tax_and_levies: 0, gst: 0, discount_category: {}, discount: 0, port_charges: 0, gratuity: 0, fuel_surcharge: 0 });
    setCabinCategoryData({});
    setCabinData([]);
    //fetching rooms data
    getAvailableRoomData(option?.value, specialPricingUpgradeOffer.specialPricing, specialPricingUpgradeOffer.upgradeOffer);
  }

  const getAvailableRoomData = async (id: string, specialPricing: boolean, upgradeOffer: boolean) => {
    setLoader(true);
    const response = await getAvailableRooms([id], payloadObj?.preference, specialPricing, upgradeOffer)
    if (response.status === 200 || response.status === 201) setCabinData(response?.result);
    setLoader(false);
  }

  // useEffect to setContextData again if page reloads
  useEffect(() => {
    const fetchData = async () => {
      if (customerId && !selectedUser?.email) {
        const data = await getCustomerDataById(customerId);
        if (data?.status === 200) {
          let userData = data?.result;
          handleSelectedUser(userData);
        }
        const existEnquiry = await checkExistCustomerEnquiry(customerId);
        if (existEnquiry.status === 200) {
          handleExistingEnquiry(existEnquiry?.result);
          setPayloadObj({ ...payloadObj, enquiryId: existEnquiry?.result?.id });
        }
      }
    };
    fetchData();
  }, []);

  // useEffect to fetch page data
  useEffect(() => {
    if (!!existingEnquiry?.id && !!selectedUser?.email) {
      getItineraryOption(existingEnquiry?.id);
      const response: any = getCommonOption();
      if (response && response.status === 200) {
        setCommonOption(response?.result)
      }
    }
  }, [existingEnquiry]);

  //useEffect to get available rooms on preference change
  useEffect(() => {
    if (payloadObj?.itineraryId) {
      setNetPrice({ total: 0, cabin_names: [], cabin_fares: [], ssr_names: [], ssr_fares: [], service_tax_and_levies: 0, gst: 0, discount_category: {}, discount: 0, port_charges: 0, gratuity: 0, fuel_surcharge: 0 });
      setCabinCategoryData({});
      setCabinData([]);
      getAvailableRoomData(payloadObj?.itineraryId, specialPricingUpgradeOffer.specialPricing, specialPricingUpgradeOffer.upgradeOffer);
    }
  }, [payloadObj.preference, specialPricingUpgradeOffer.specialPricing, specialPricingUpgradeOffer.upgradeOffer]);

  //useEffect to getTotalPrice on room/ssr addition
  useEffect(() => {
    const valArray: any[] = Object.values(cabinCategoryData);
    const combinedArray = [].concat(...valArray);

    if (!combinedArray.length) {
      setShow(false);
      setNetPrice({ total: 0, cabin_names: [], cabin_fares: [], ssr_names: [], ssr_fares: [], service_tax_and_levies: 0, gst: 0, discount_category: {}, discount: 0, port_charges: 0, gratuity: 0, fuel_surcharge: 0 });
      setPayloadObj({ ...payloadObj, rooms: [] });
      handleAddRemoveCabinLoader(false);
      return;
    }

    const fetchData = async () => {
      if (!!combinedArray?.length && !!payloadObj?.itineraryId) {
        const data = await getQuotationRoomPrices({
          itinerary_id: payloadObj?.itineraryId,
          rooms: [...combinedArray],
          special_request_ids: [...payloadObj?.special_request_ids],
          special_pricing: specialPricingUpgradeOffer.specialPricing,
          upgrade_offer: specialPricingUpgradeOffer.upgradeOffer
        });
        if (data?.response?.status === 400) {
          snackbarCtx.toggleSnackbar({ message: data?.response?.data?.message, type: 'FAILURE', visible: true });
          handleLastCabinUpdates(lastCabinUpdates.lastCabinId, true);
          handleAddRemoveCabinLoader(false);
          return;
        }
        setPayloadObj({ ...payloadObj, rooms: [...combinedArray] });
        if (data?.status === 201) {
          const { result } = data;
          let tempObj: any = { total: 0, cabin_names: [], cabin_fares: [], ssr_names: [], ssr_fares: [], service_tax_and_levies: 0, gst: 0, discount_category: {}, discount: 0, port_charges: 0, gratuity: 0, fuel_surcharge: 0 };
          result?.forEach((value: any) => {
            let discountCategoryObject: any[] = [];
            if (!!value?.discount_category?.length) {
              discountCategoryObject = value?.discount_category?.reduce((acc: any, discountName: string) => {
              acc[discountName] = true;
              return acc;
            }, {});
            }
            if (value.type === 'CABIN') {
              tempObj = {
              ...tempObj,  
              total: tempObj.total + value.cabin_fare + value.service_tax_and_levies + value.gst + value.fuel_surcharge,
              cabin_names: [...tempObj.cabin_names, value.title],
              cabin_fares: [...tempObj.cabin_fares, value.cabin_fare],
              service_tax_and_levies: tempObj.service_tax_and_levies + value.service_tax_and_levies,
              gst: tempObj.gst + value.gst,
              discount_category: { ...tempObj.discount_category, ...discountCategoryObject },
              discount: tempObj.discount + value.discount,
              port_charges: tempObj.port_charges + value.port_charges,
              fuel_surcharge: tempObj.fuel_surcharge + value.fuel_surcharge,
              gratuity: tempObj.gratuity + value.gratuity
            };
            } else {
              tempObj = {
                ...tempObj,  
                total: tempObj.total + value.total + value.service_tax_and_levies + value.gst + value.fuel_surcharge,
                ssr_names: [...tempObj.ssr_names, value.title],
                ssr_fares: [...tempObj.ssr_fares, value.total],
                service_tax_and_levies: tempObj.service_tax_and_levies + value.service_tax_and_levies,
                gst: tempObj.gst + value.gst,
                discount_category: { ...tempObj.discount_category, ...discountCategoryObject },
                discount: tempObj.discount + value.discount,
                port_charges: tempObj.port_charges + value.port_charges,
                fuel_surcharge: tempObj.fuel_surcharge + value.fuel_surcharge,
                gratuity: tempObj.gratuity + value.gratuity
              };
            }
          });
          setNetPrice({ ...tempObj });
          setShow(!!tempObj?.total);  
          handleAddRemoveCabinLoader(false);
        }
      }
    };
    
    fetchData();
  }, [cabinCategoryData, payloadObj.special_request_ids]);

  return (
    <div className="build-quotation">
      <Card className="border" style={{ marginTop: 20 }}>
        <Card.Body>
          <div className="flex justify-between items-end ml-5 w-[55%]">
            <span className="text-xl font-bold text-[#595c5f] text-uppercase">Build Quotation</span>
            <CustomSelect onChange={(option) => handleItineraryOptionChange(option)} options={itineraryDetails} value={payloadObj?.itineraryId}/>
          </div>
          <div className="flex flex-wrap justify-content-evenly h-100 py-4">
            <div className="w-[55%] " >
              <Card className="border h-100" style={{ marginTop: 20 }}>
                <Card.Body>
                  <AssignCabin
                    payloadObj={payloadObj}
                    setPayloadObj={setPayloadObj}
                    loader={loader}
                    cabinsData={cabinsData}
                    commonOption={commonOption}
                    cabinCategoryData={cabinCategoryData}
                    setCabinCategoryData={setCabinCategoryData}
                    setSpecialPricingUpgradeOffer={setSpecialPricingUpgradeOffer}
                    specialPricingUpgradeOffer={specialPricingUpgradeOffer}
                  />
                </Card.Body>
              </Card>
            </div>
            <div className="w-[40%]" >
              <PriceDetail show={show} setShow={setShow} netPrice={netPrice} payloadObj={payloadObj} setPayloadObj={setPayloadObj} setStepNumber={setStepNumber} itineraryDetails={itineraryDetails} specialPricingUpgradeOffer={specialPricingUpgradeOffer} />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default BuildQuotation;
